import { FACET_ORDER, facetOf, isFacetTag } from "@gooner/shared";

/**
 * Where clicking a keyword pill should take you on /browse.
 *
 * A pill used to navigate to a bare `/browse?tag=<slug>`, so clicking "Latina" in a
 * clip opened from a filtered, sorted, paged grid threw every filter and the sort away
 * (Casey 2026-10-20 evening Medium).
 *
 * Now: when you are already on /browse, the current filters and sort are kept and the
 * page resets. A facet keyword (`race:latina`) whose facet has a sidebar group sets that
 * group's own param (`race=latina`) — the same param the sidebar writes, so the group
 * lights up and a second value in the facet REPLACES the first, as a sidebar click
 * would. Any other keyword sets `?tag=` (one keyword at a time, as before). From
 * anywhere else it starts from an empty query with `?tag=`, as before.
 */
export function browseHrefForTag(slug: string, current: URLSearchParams | null): string {
  const p = new URLSearchParams(current ?? undefined);
  const facet = current ? facetOf(slug) : null;
  if (facet && isFacetTag(slug) && FACET_ORDER.includes(facet)) {
    p.set(facet, slug.slice(facet.length + 1).toLowerCase());
    // A `?tag=` from the same facet (an old link: `?tag=race:latina`) would AND against
    // the new value and empty the grid; the sidebar param now says it.
    const t = p.get("tag");
    if (t && facetOf(t) === facet) p.delete("tag");
  } else {
    p.set("tag", slug);
  }
  p.delete("page");
  return `/browse?${p.toString()}`;
}
